import styled from "styled-components";
import Flex from "../Flex";
import { colorMixin } from "../../helpers";

export const Popover = styled(Flex)`
    background: ${colorMixin("background-primary-base")};
    border-radius: 4px;
    box-shadow: 0 1px 5px ${colorMixin("border-primary-200")};

    :hover {
        border-color: ${colorMixin("border-primary-200")};
    }
`;

export const Underlay = styled.div`
    position: fixed;
    inset: 0;
`;
